import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthAssetsService } from './auth-assets.service';
import { RoutesPath } from '../../routes-path';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public authAssets: AuthAssetsService, public router: Router) {}

  canActivate(): boolean {
    if (!this.authAssets.isAuthenticated()) {
      this.router.navigate([RoutesPath.default.home]);
      return false;
    }
    return true;
  }
}
